import { Directive, ElementRef, Input, SimpleChanges } from '@angular/core';

import { SendSubTypes } from '../api/models';

@Directive({
  selector: '[sendSubTypeStyle]',
  standalone: true,
})
export class SendSubTypesDirective {
  @Input('sendSubTypeStyle') type: SendSubTypes;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {
    let classList = 'badge tw-font-bold border ';

    switch (this.type) {
      case SendSubTypes.Direct:
        classList += 'badge-light-navyBlue border-navyBlue';
        break;
      case SendSubTypes.Periodic:
        classList += 'badge-light-warning border-warning';
        break;
      case SendSubTypes.Gradual:
        classList += 'badge-light-info border-info';
        break;
      // case SendSubTypes.GradualPeriodic:
      //   classList += 'badge-light-blue border-blue';
      //   break;

      default:
        break;
    }

    return classList;
  }
}
